import { fetchPushRecentSearch, fetchAppContext } from '@growth/api-calls';
import { safeStringify } from '@growth/object-utils';
import { docLocalStorage } from '@growth/browser-storage';
import { isValidLobName } from '@growth/validations';
import { getEncryptedUuid } from '@growth/auth-utils';

function _regeneratorRuntime() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  _regeneratorRuntime = function () {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) keys.push(key);

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

/*
 https://dev.to/alexeagleson/how-to-use-indexeddb-to-store-data-for-your-web-application-in-the-browser-1o90#browsing-your-database
*/
var requestIndexDB = function requestIndexDB(name, ver) {
  if (!name || !ver) {
    throw new Error('name or ver argument is missing for requestIndexDB');
  }

  var indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB || window.shimIndexedDB;
  return new Promise(function (resolve, reject) {
    if (!indexedDB) {
      reject(new Error('IndexedDB could not be found in this browser.'));
    }

    var request = indexedDB.open(name, ver);
    resolve(request);
  });
};

var DB_NAME = 'GROW_LS'; // latest searches;

var DB_VER = 1;
var DB_OBJECT_NAME = 's';

var bootstrapBookingDB = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var request;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return requestIndexDB(DB_NAME, DB_VER);

          case 3:
            request = _context.sent;

            request.onupgradeneeded = function () {
              var db = request.result;
              db.createObjectStore(DB_OBJECT_NAME, {
                keyPath: 'lob'
              });
            };

            return _context.abrupt("return", request);

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", Promise.reject(new Error()));

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8]]);
  }));

  return function bootstrapBookingDB() {
    return _ref.apply(this, arguments);
  };
}();

var saveLatestInLocal = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(searchRecord) {
    var request;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return bootstrapBookingDB();

          case 2:
            request = _context2.sent;

            request.onsuccess = function () {
              var db = request.result;
              var transaction = db.transaction(DB_OBJECT_NAME, 'readwrite');
              var store = transaction.objectStore(DB_OBJECT_NAME);
              store.put(searchRecord);

              transaction.oncomplete = function () {
                db.close();
              };
            };

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function saveLatestInLocal(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var getLatestLocalSearch = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(lob) {
    var request;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (lob) {
              _context3.next = 2;
              break;
            }

            return _context3.abrupt("return", Promise.reject(Error('lob name is missing for getLocalSearch() call')));

          case 2:
            _context3.next = 4;
            return bootstrapBookingDB();

          case 4:
            request = _context3.sent;
            return _context3.abrupt("return", new Promise(function (resolve, reject) {
              request.onsuccess = function () {
                var db = request.result;
                var transaction = db.transaction(DB_OBJECT_NAME, 'readonly');
                var store = transaction.objectStore(DB_OBJECT_NAME);
                var records = store.get(lob);

                records.onsuccess = function () {
                  resolve(records.result);
                };

                request.onerror = function () {
                  reject(records.result);
                };

                transaction.oncomplete = function () {
                  db.close();
                };
              };
            }));

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function getLatestLocalSearch(_x2) {
    return _ref3.apply(this, arguments);
  };
}();

var pushSearchesToApi = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(arg) {
    var _searchDetails$search, _searchDetails$search2, _searchDetails$search3, _searchDetails$search4;

    var lobName, searchDetails, onPushSuccess, onPushFail, shouldKeepLatestSearchInLocal, record, _searchDetails$search5, _searchDetails$search6, res, _ref2, tag_id, go_data, searches, _res;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            lobName = arg.lobName, searchDetails = arg.searchDetails, onPushSuccess = arg.onPushSuccess, onPushFail = arg.onPushFail, shouldKeepLatestSearchInLocal = arg.shouldKeepLatestSearchInLocal;
            record = {
              datasetName: 'gi_recent_searches_aero',
              column: lobName,
              // flights/hotels/train/bus/cab/holidays/acme/tripideas
              value: _extends({}, searchDetails, {
                searchContext: _extends({
                  language: 'eng',
                  // eng/hin
                  region: 'in',
                  profile: 'PERSONAL',
                  timestamp: Date.now()
                }, searchDetails.searchContext)
              })
            }; // Append the godata & tagid if not passed from lobs. This will ensure the same search record works in app and web

            if (!(!(searchDetails != null && (_searchDetails$search = searchDetails.searchContext) != null && (_searchDetails$search2 = _searchDetails$search.meta) != null && _searchDetails$search2.gd) || !(searchDetails != null && (_searchDetails$search3 = searchDetails.searchContext) != null && (_searchDetails$search4 = _searchDetails$search3.meta) != null && _searchDetails$search4.tg))) {
              _context.next = 14;
              break;
            }

            _context.prev = 3;
            _context.next = 6;
            return fetchAppContext(searchDetails == null ? void 0 : (_searchDetails$search5 = searchDetails.searchContext) == null ? void 0 : (_searchDetails$search6 = _searchDetails$search5.meta) == null ? void 0 : _searchDetails$search6.deeplink);

          case 6:
            res = _context.sent;

            /* eslint-disable-next-line @typescript-eslint/naming-convention */
            _ref2 = (res == null ? void 0 : res.data) || {}, tag_id = _ref2.tag_id, go_data = _ref2.go_data;
            if (tag_id) record.value.searchContext.meta.tg = tag_id;
            if (go_data) record.value.searchContext.meta.gd = safeStringify(go_data);
            _context.next = 14;
            break;

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](3);

          case 14:
            searches = [record];
            _context.prev = 15;
            _context.next = 18;
            return fetchPushRecentSearch(searches);

          case 18:
            _res = _context.sent;

            /* Keep the last search in indexDB */
            if (shouldKeepLatestSearchInLocal) {
              saveLatestInLocal(record.value.searchContext);
            } // you may want to call the get api and update the cache after push


            onPushSuccess == null ? void 0 : onPushSuccess(_res);
            return _context.abrupt("return", _res);

          case 24:
            _context.prev = 24;
            _context.t1 = _context["catch"](15);
            onPushFail == null ? void 0 : onPushFail(_context.t1);

          case 27:
            return _context.abrupt("return", undefined);

          case 28:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 12], [15, 24]]);
  }));

  return function pushSearchesToApi(_x) {
    return _ref.apply(this, arguments);
  };
}();

var dictionary = {
  id: 'id',
  tagId: 'tg',
  godata: 'gd',
  title: 't',
  subTitle: 'st',
  lobName: 'v',
  source: 'src',
  destination: 'dst',
  shouldDisplayDate: 'dd',
  roomDetails: 'rmd',
  name: 'n',
  paxCount: 'pxc',
  roomCount: 'rmc',
  roomType: 'rmt',
  subLob: 'sl',
  version: 'vs',
  updatedTime: 'ut',
  isDailyStealDeal: 'dsd',
  traveldate: 'td',
  createdTime: 'ct',
  returnDate: 'rd',
  url: 'link',
  userId: 'uid'
};

var RECENT_SEARCH_STORAGE_KEY = '_gi_grow_r_srch';
var RECENT_SEARCH_STORAGE_GUEST_KEY = '_gi_grow_r_srch_guest';
var RECENT_SEARCH_LENGTH_THRESHOLD = 4;

var deleteOldSearch = function deleteOldSearch(searchList) {
  if (searchList === void 0) {
    searchList = {};
  }

  /**
   * delete search which is expired
   * if limit exceeds then delete sabse purana search
   */
  var allSearchCard = Object.values(searchList) || [];
  var oldestCard = allSearchCard.length ? allSearchCard[0] : undefined;
  allSearchCard.forEach(function (item) {
    var travelStartDate = item[dictionary.traveldate];
    var ut = item[dictionary.updatedTime];
    var ct = item[dictionary.createdTime];
    var isExpired = false;

    if (travelStartDate) {
      // if travel start date is less than current date then remove the card
      var currentDate = new Date().setHours(0, 0, 0, 0);
      var travelDate = new Date(travelStartDate).setHours(0, 0, 0, 0);
      isExpired = currentDate > travelDate;
    }

    if (ut) {
      if (oldestCard) oldestCard = oldestCard[dictionary.updatedTime] > ut ? item : oldestCard;
    } else if (ct) {
      if (oldestCard) oldestCard = oldestCard[dictionary.createdTime] > ct ? item : oldestCard;
    }

    if (isExpired) {
      var modifiedList = searchList;
      delete modifiedList[item.id];
    }
  }); // checking if search list is full then remove old search

  var allSearchList = Object.keys(searchList) || [];

  if (allSearchList.length > RECENT_SEARCH_LENGTH_THRESHOLD && oldestCard) {
    var modifiedList = searchList;
    delete modifiedList[oldestCard.id];
  }
};

var doRecentSearchMigration = function doRecentSearchMigration(userId, searchList) {
  var searchKey = userId || RECENT_SEARCH_STORAGE_GUEST_KEY;

  if (userId && searchList[RECENT_SEARCH_STORAGE_GUEST_KEY]) {
    var nonLoggedInData = searchList[RECENT_SEARCH_STORAGE_GUEST_KEY] || {}; // eslint-disable-next-line no-param-reassign

    searchList[searchKey] = _extends({}, searchList[searchKey], nonLoggedInData); // eslint-disable-next-line no-param-reassign

    delete searchList[RECENT_SEARCH_STORAGE_GUEST_KEY];
    docLocalStorage.setItem(RECENT_SEARCH_STORAGE_KEY, searchList);
  }
};

var getRecentSearch = function getRecentSearch(params) {
  var lobName = params.lobName,
      _params$allList = params.allList,
      allList = _params$allList === void 0 ? false : _params$allList;
  var noFilter = allList;
  var userId = getEncryptedUuid();

  if (!isValidLobName(lobName)) {
    console.error('LobName is not valid for RecentSearch');
    return [];
  } //	this.userId = userId;


  var allSearches = docLocalStorage.getItem(RECENT_SEARCH_STORAGE_KEY) || {};
  var searchKey = userId || RECENT_SEARCH_STORAGE_GUEST_KEY;
  /**
   * check if RECENT_SEARCH_STORAGE_GUEST_KEY has data and user is loggedIn then
   * transfer all data to user id and delete RECENT_SEARCH_STORAGE_GUEST_KEY
   * and then update local storage
   */

  doRecentSearchMigration(userId, allSearches);

  try {
    deleteOldSearch(allSearches[searchKey]);
  } catch (e) {
    console.log('error while deleting ', e);
  } // return array of objects


  var searchListObj = allSearches[searchKey] || {};
  var list = Object.values(searchListObj);

  if (list.length > 1) {
    list.sort(function (a, b) {
      var key1 = new Date(a[dictionary.updatedTime] || a[dictionary.createdTime]);
      var key2 = new Date(b[dictionary.updatedTime] || b[dictionary.createdTime]); // Compare the 2 dates

      if (key1 > key2) return -1;
      if (key1 < key2) return 1;
      return 0;
    });
  }

  if (noFilter) return list;
  return list.filter(function (item) {
    return item[dictionary.lobName] === lobName;
  });
};

var setData = function setData(data) {
  /**
   * encode the keys with mapped Dictionary and return the searched object
   */
  var recentSearchData = {};
  Object.keys(data).forEach(function (item) {
    if (dictionary[item]) {
      // console.log('dictionary item',dictionary[item])
      recentSearchData[dictionary[item]] = data[item];
    } else console.log('Given key is not supported for recent search format. Please check the recent search payload and keys for lobs on readme.');
  });
  recentSearchData[dictionary.shouldDisplayDate] = recentSearchData[dictionary.shouldDisplayDate] || true;
  return recentSearchData;
};

var updatingRecentSearchRecord = function updatingRecentSearchRecord(_ref) {
  var _allSearches$searchKe;

  var allSearches = _ref.allSearches,
      searchKey = _ref.searchKey,
      id = _ref.id,
      params = _ref.params;
  var isSearchAlreadyPresent = !!((_allSearches$searchKe = allSearches[searchKey]) != null && _allSearches$searchKe[id]);
  var updatingData = isSearchAlreadyPresent ? _extends({}, allSearches[searchKey][id], setData(params)) : setData(params);

  if (isSearchAlreadyPresent) {
    updatingData[dictionary.updatedTime] = new Date().getTime();
  } else {
    updatingData[dictionary.createdTime] = new Date().getTime();
  }

  return updatingData;
};

var setRecentSearch = function setRecentSearch(params) {
  var _extends2;

  var id = params.id;
  var userId = getEncryptedUuid();

  if (!id) {
    throw new Error('Required argument id is missing for function call - setRecentSearch');
  }

  var allSearches = docLocalStorage.getItem(RECENT_SEARCH_STORAGE_KEY) || {};
  /** If user loggedIn we get userId otherwise
   * it will consider not loggedIn and set values in RECENT_SEARCH_STORAGE_GUEST_KEY
   */

  var searchKey = userId || RECENT_SEARCH_STORAGE_GUEST_KEY;
  /**
   * If user is loggedIn and RECENT_SEARCH_STORAGE_GUEST_KEY has data then move that data to userId and delete RECENT_SEARCH_STORAGE_GUEST_KEY data
   */

  doRecentSearchMigration(userId, allSearches);
  /**
   * for given searchKey check if search is new or already exist,
   * if exist then overwrite updating keys
   */

  var updatingData = updatingRecentSearchRecord({
    allSearches: allSearches,
    searchKey: searchKey,
    id: id,
    params: params
  });
  allSearches[searchKey] = _extends({}, allSearches[searchKey], (_extends2 = {}, _extends2[id] = updatingData, _extends2));
  deleteOldSearch(allSearches[searchKey]);
  docLocalStorage.setItem(RECENT_SEARCH_STORAGE_KEY, allSearches);
};

var getAllRecentSearch = function getAllRecentSearch(params) {
  return getRecentSearch(_extends({}, params, {
    allList: true
  }));
};

export { RECENT_SEARCH_LENGTH_THRESHOLD, RECENT_SEARCH_STORAGE_GUEST_KEY, RECENT_SEARCH_STORAGE_KEY, getAllRecentSearch, getLatestLocalSearch, getRecentSearch, pushSearchesToApi, setRecentSearch };
